import React from 'react'
import { Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import CountUp from 'react-countup';
class FourBlockDivision extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    goToPage(e, pageType, pageName) {
        dispatch.home.redirectFromEventStream(true)
        const history = this.props.history;
        let urlPath = ""

        if (pageType === 'initiative') {

            if (pageName === "In Design") {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_in/indesign'
                dispatch.initiatives.setTreeCurrentPath("0/1")
            } else if (pageName === "Active") {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_in/active'
                dispatch.initiatives.setTreeCurrentPath("0/2")
            } else if (pageName === "Closed") {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_in/closed'
                dispatch.initiatives.setTreeCurrentPath("0/3")
            } else if (pageName === "Completed") {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_in/completed'
                dispatch.initiatives.setTreeCurrentPath("0/1")
            } else if (pageName === "Cancelled") {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_in/cancelled'
                dispatch.initiatives.setTreeCurrentPath("0/4")
            }
            history.push({
                pathname: urlPath
            });
        } else if (pageType === 'content') {
            dispatch.content.setContentList([]);
            //let statusQuery = {}
            if (pageName === 'In Design') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/in_development'
                dispatch.content.setTreeCurrentPath("0/0")
            } else if (pageName === 'Published') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/published'
                dispatch.content.setTreeCurrentPath("0/1")
            } else if (pageName === 'Approved') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/approved'
            } else if (pageName === 'Purchased') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/Purchased'
            }

            history.push({
                pathname: urlPath
            });
        }

    }


    render() {

        return (
            <Grid celled='internally' className="count-block-item setHoverEffect" >
                <Grid.Row>
                    <Grid.Column width={8} onClick={(e) => this.goToPage(e, this.props.type, this.props.label1Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label1Count} duration={5} /> :
                            <span>{this.props.label1Count}</span>
                        }
                        <label>{this.props.label1Name}</label>
                    </Grid.Column>
                    <Grid.Column width={8} onClick={(e) => this.goToPage(e, this.props.type, this.props.label2Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label2Count} duration={5} /> :
                            <span>{this.props.label2Count}</span>
                        }
                        <label>{this.props.label2Name}</label>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8} onClick={(e) => this.goToPage(e, this.props.type, this.props.label3Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label3Count} duration={5} /> :
                            <span>{this.props.label3Count}</span>
                        }
                        <label>{this.props.label3Name}</label>
                    </Grid.Column>

                    <Grid.Column className={`${this.props.type === "playbook" && this.props.label4Name === "Purchased" ? "grayedOut" : ""}`} width={8} onClick={(e) => this.goToPage(e, this.props.type, this.props.label4Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label4Count} duration={5} /> :
                            <span>{this.props.label4Count}</span>
                        }
                        <label>{this.props.label4Name}</label>
                    </Grid.Column>
                </Grid.Row>
            </Grid >
        )
    }
}


export default withRouter(FourBlockDivision);;